import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spacer } from "@chakra-ui/react";

import PrimaryButton from "components/PrimaryButton";
import ConditionCheck from "components/ConditionCheck";
import { requestContractPath } from "constants/paths";
import { QUERY_STRING_KEYS } from "hooks/useQueryParam";
import usePermission from "hooks/usePermission";
import useGetProductList from "hooks/api/products/useGetProductList";
import useFeatureFlag from "hooks/useFeatureFlag";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import { CONTRACT } from "util/featureFlags";

const BUTTON_VARIANT = mobileStyleBreakpoint("link", "primary");

const RequestContractButton = () => {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const navigateToRequestContractPage = useCallback(
    () =>
      navigate(
        `/${requestContractPath}?${
          QUERY_STRING_KEYS.SELECTED_CUSTOMER_KEY
        }=${search.get(QUERY_STRING_KEYS.SELECTED_CUSTOMER_KEY)}`
      ),
    [navigate, search]
  );
  const hasRequestContractFeature = useFeatureFlag(CONTRACT.REQUEST);
  const hasRequestContractPermission = usePermission(CONTRACT.REQUEST);
  const { data } = useGetProductList();
  return (
    <ConditionCheck
      conditions={[
        hasRequestContractFeature,
        hasRequestContractPermission,
        (data?.length ?? 0) > 0,
      ]}
      fallback={<Spacer />}
    >
      <PrimaryButton
        onClick={navigateToRequestContractPage}
        variant={BUTTON_VARIANT}
      >
        Request Contract
      </PrimaryButton>
    </ConditionCheck>
  );
};

export default RequestContractButton;
